import React, { useMemo } from "react";

import BuildOwnTemplateBanner from "@sharedComponents/banner/build-own-template";
import ListTemplateView from "@components/all-templates/views/list-view";
import GridTemplateView from "@components/all-templates/views/grid-view";

import { buildOwnTemplateBannerData } from "@constants/banner";
import { DEFAULT_ACCOUNT_SHOP_LONG_DES } from "@constants/templates-listing/info-pop-up";
import { MOMENTS } from "@constants/routes";

import styles from "./purge-main.module.scss";

const defaultObj = {};

const AccountShops = ({
  shops,
  isGridView,
  onTemplateSelect = () => {},
  pageName = "",
} = defaultObj) => {
  const modifiedShops = useMemo(
    () =>
      shops.map((shop) => {
        return {
          ...shop,
          shortDescription: shop?.storeDetail?.shortDescription,
          longDescription: shop?.storeDetail.longDescription || DEFAULT_ACCOUNT_SHOP_LONG_DES,
        };
      }),
    [shops],
  );

  return (
    <div className={styles.templatesContentSection}>
      {modifiedShops.map((shop, index) => (
        <React.Fragment key={shop.id}>
          {index === 4 && pageName !== MOMENTS && (
            <BuildOwnTemplateBanner
              key={buildOwnTemplateBannerData.name}
              data={buildOwnTemplateBannerData}
              onTemplateSelect={onTemplateSelect}
              className={styles.listingTemplateRequestBanner}
            />
          )}
          <div
            className={`${styles.templateBlockHolder} ${isGridView ? styles.gridViewClasses : ""}`}
          >
            {!isGridView ? (
              <ListTemplateView {...shop} onTemplateSelect={onTemplateSelect} pageName={pageName} />
            ) : (
              <GridTemplateView {...shop} onTemplateSelect={onTemplateSelect} pageName={pageName} />
            )}
          </div>
        </React.Fragment>
      ))}
    </div>
  );
};

export default AccountShops;
